import z from 'zod';
import { partySchema } from '../../common';
import { phoneSchema } from '../../validation';

/**
 * The person responsible for handling this order (creator by default;
 * reassignable).
 *
 * This is who the team — and Hero AI — go back to for updates, questions,
 * and messaging on the order. Defaults to the creating user. Dashboard
 * users can reassign to another org member. `phone` is the E.164 snapshot
 * used as the default messaging target (e.g. auto WhatsApp waybill).
 *
 * Phase 7 (relations-v2): party-shaped snapshot (`target` + `_id` + `ids[]`).
 * Also stamps `{ type: 'phone', id }` into `ids[]` when written.
 */
export const orderOwnerSchema = partySchema.extend({
  /** E.164 phone snapshot used as the default messaging / AI contact target. */
  phone: phoneSchema,
});
export type OrderOwner = z.infer<typeof orderOwnerSchema>;
